import isArray from "lodash/isArray"
import identity from "lodash/identity"
import { compose, mapProps } from "recompact"

export default function preparePluginsApplier(plugins) {
  if (!isArray(plugins)) {
    return () => mapProps(identity)
  }
  return stage => {
    const stagedPlugins = plugins.map(plugin => plugin[stage]).filter(Boolean)
    return stagedPlugins.length ? compose(...stagedPlugins) : mapProps(identity)
  }
}
